let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jMhdy")).then(() => parcelRequire('6ElUV'));